import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService, AlertService, GlobalService } from '../_services';
import { Router } from '@angular/router';
import { CloseOverlayService } from '../_services/closeOverlay.service';

@Injectable({
  providedIn: 'root'
})

export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthenticationService, private alertService: AlertService,
    private router: Router, private closeOverlayService: CloseOverlayService,
    private globalService: GlobalService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401 && err.error.message.includes('token expired')) {
        // auto logout if 401 response returned from api
        this.auth.logout();
        // this.alertService.loadingNullDuration('Session Timed Out. Please login again');
        this.router.navigateByUrl('/login');
      }
      if ((err.status === 0 || err.statusText.includes('Unknown Error'))) {
        if (this.router.url !== '/dashboard' && this.router.url !== '/confirm-payment' &&
        this.router.url !== '/demo/confirm' && this.router.url !== '/login') {
        this.alertService.loadingNullDuration(this.globalService.errorText.oops +
        this.globalService.errorText.persists);
        }
      }
      const error = err;
      return throwError(error);
    }));
  }
 }
